import styles from '@components/components/CmsComponents/components/CmsGroup/CmsGroup.module.scss';
import ScrollObserver from '@components/components/ScrollObserver/ScrollObserver';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const CmsGroup = ({
  CmsComponents,
  ScrollIndexVertical,
  anchor,
  blocks,
  background = '',
  className,
  containerDimension,
  groupTheme = 'default',
  trackingName,
}) => {
  if (!blocks || blocks?.length === 0) {
    // eslint-disable-next-line no-console
    console.warn(
      'Wien Energie Components: Check the WordPress Gutenberg editor for empty group blocks on this page.',
    );
    return null;
  }

  const children = (
    <div
      className={classNames(styles[background], className, {
        [styles.scrollMargin]: anchor,
      })}
      id={anchor}
    >
      {blocks.map(block => (
        <CmsComponents
          data={{
            ...block,
            noMargin: true,
            groupTheme,
            trackingName,
            containerDimension,
          }}
          key={block.id}
          scrollIndex={ScrollIndexVertical}
        />
      ))}
    </div>
  );

  return trackingName ? (
    <ScrollObserver
      ScrollIndexVertical={ScrollIndexVertical}
      trackingName={trackingName}
    >
      {children}
    </ScrollObserver>
  ) : (
    children
  );
};

CmsGroup.propTypes = {
  CmsComponents: PropTypes.func.isRequired,
  ScrollIndexVertical: PropTypes.number,
  anchor: PropTypes.string,
  background: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  blocks: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  containerDimension: PropTypes.string,
  groupTheme: PropTypes.string,
  trackingName: PropTypes.string,
};

CmsGroup.size = 'full';

export default CmsGroup;
